







import Vue from "vue";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
  name: "PageTitle",
  computed: {
    viewTitle(): string | TranslateResult {
      switch (this.$route.name) {
        case "Home":
          return this.$t("home.viewTitle");
        case "Analytics":
          return this.$t("analytics.viewTitle.analytics");
        case "NewReport":
          return this.$t("analytics.viewTitle.newReport");
        case "EditReport":
          return this.$t("analytics.viewTitle.editReport");
        case "AdunitGroup":
          return this.$t("adUnitGroup.viewTitle.adUnitGroup");
        case "AdunitGroupSetting":
          return this.$t("adUnitGroup.viewTitle.newAdUnitGroup");
        case "AdunitGroupEdit":
          return this.$t("adUnitGroup.viewTitle.editAdUnitGroup");
        case "Wrapper":
          return this.$t("wrapper.viewTitle");
        case "Engagement":
          return this.$t("engagement.viewTitle");
        case "Layout":
          return this.$t("layout.viewTitle");
        case "IdManager":
          return this.$t("idManager.viewTitle");
        case "CoreWebVitals":
          return this.$t("coreWebVitals.viewTitle");
        case "ReleaseNote":
          return this.$t("releaseNote.viewTitle");
        case "Help":
          return this.$t("helpCenter.viewTitle");
        case "Setting":
          return this.$t("settings.viewTitle");
        default:
          return "";
      }
    },
  },
});
